import { Box } from "@mui/material";

type TimelineIconProps = {
    borderColor: string;
    backgroundColor: string;
    icon: React.ReactNode;
};

const TimelineIcon: React.FC<TimelineIconProps> = ({ borderColor, backgroundColor, icon }) => (
    <Box
        sx={{
            width: 40,
            height: 40,
            border: '2px solid',
            borderColor: borderColor,
            borderRadius: '50%',
            backgroundColor: backgroundColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1
        }}
    >
        <Box
            component="span"
            sx={{
                color: borderColor,
                fontSize: 20,
                display: 'flex',
                alignItems: 'center'
            }}
        >
            {icon}
        </Box>
    </Box>
);

export { TimelineIcon };